import { create } from 'zustand';

export const usePeekStore = create((set) => ({
  peek: null,
  openPeek: (peek) => set({ peek }),
  closePeek: () => set({ peek: null }),
}));
